// Selected B4 optical particle field. Original project shaders.
export const vertex = `precision highp float;
 attribute vec4 seed;uniform float time,pass,pointScale;uniform vec2 pointer;varying float brightness;varying float depth;varying float bead;varying float visibility;
 void main(){
  float t=time*.085;
  float u=seed.x*2.-1.,v=seed.y*2.-1.;
  float z=seed.z*2.-1.;
  // A turbulent luminous volume, wide enough to enter and leave the frame.
  float x=u*2.1;
  float crest=.19*sin(u*4.+z*.9+t)+.16*sin(u*2.2-z*1.3-.5);
  float thickness=.23+.10*cos(u*2.3+z);
  float y=-.78+crest+v*thickness;
  y+=.13*sin(z*3.+u*1.8+t*.7);
  x+=.065*sin(z*4.+v*3.+t);
  float perspective=1./(1.8+z*.36);
  vec2 p=vec2(x*perspective,y*perspective);
  // The camera sees the front of the volume and its recession into depth.
  p.y+=.07*z;
  vec2 m=(pointer-.5)*2.;
  vec2 delta=p-m;
  float influence=exp(-dot(delta,delta)*10.);
  p+=delta*influence*(.16+.08*(1.-seed.z));
  p.x+=m.x*.035*(z+.8);p.y+=m.y*.04*z;
  gl_Position=vec4(p,0.,1.);
  depth=1.-seed.z;
  brightness=(.12+.50*pow(seed.w,3.))*(.25+.75*pow(1.-abs(v),2.));
  brightness*=.65+.35*sin(u*5.-t*1.3+z*1.6);
  float quiet=exp(-pow(p.x/.65,4.))*smoothstep(-.62,-.32,p.y);
  visibility=(1.-quiet*.97)*(.5+.5*pow(1.-abs(v),.5));
  brightness*=1.-quiet*.97;
  brightness*=4.2;
  bead=step(.992,seed.w);
  float tier=step(.998,seed.w);
  float beadSize=mix(4.4,9.,tier)*(.65+depth*.55);
  gl_PointSize=pointScale*(pass>1.5?beadSize:(pass>.5?(12.+depth*13.):(1.1+depth*1.8)));
 }`;
export const fragment = `precision highp float;varying float brightness;varying float depth;varying float bead;varying float visibility;uniform float pass;
 void main(){
  vec2 q=gl_PointCoord-.5;float r=dot(q,q);if(r>.25)discard;
  if(pass>1.5){
   vec2 xy=vec2(q.x,-q.y)*2.;float rr=dot(xy,xy);
   vec3 normal=vec3(xy,sqrt(max(0.,1.-rr)));
   vec3 lightDirection=normalize(vec3(-.6,.8,1.2));
   float diffuse=max(0.,dot(normal,lightDirection));
   vec3 halfDirection=normalize(lightDirection+vec3(0.,0.,1.));
   float spec=pow(max(0.,dot(normal,halfDirection)),24.);
   float rim=pow(1.-normal.z,2.)*.11;
   vec3 pigment=mix(vec3(.29,.19,.43),vec3(.58,.45,.74),depth);
   vec3 color=pigment*(.2+.8*diffuse)+vec3(.95,.89,1.)*spec*.74+vec3(.62,.49,.84)*rim;
   float edge=1.-smoothstep(.64+.20*depth,1.,rr);
   gl_FragColor=vec4(color,edge*visibility*.92);
  }else{
   if(pass<.5&&bead>.5)discard;
   float light=pass>.5?exp(-r*19.)*.032:exp(-r*13.);
   vec3 col=mix(vec3(.34,.17,.61),vec3(.91,.79,1.),depth*.75);
   gl_FragColor=vec4(col*brightness*light,1.);
  }
 }`;
